<template>
  <white-block
    class="white-block-content-loader"
    :bordered="bordered"
  >
    <tm-loader>
      <template v-slot:title>
        {{ title ?? $t('whiteBlockContentLoader.title') }}
      </template>

      <template v-slot:description>
        {{ description ?? $t('whiteBlockContentLoader.description') }}
      </template>
    </tm-loader>
  </white-block>
</template>

<script setup lang="ts">
import TmLoader from '@/components/shared/TmLoader.vue'
import WhiteBlock from '@/components/shared/templates/WhiteBlock.vue'

defineProps<{
  title?: string
  description?: string
  bordered?: boolean
}>()
</script>

<style lang="scss" scoped>
.white-block-content-loader {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 123px;
  padding-bottom: 123px;
  min-height: 372px;
}
</style>
